import React from 'react';

import useCurrentUser from '~/hooks/useCurrentUser';
import useProductNavigationLinks from '~/hooks/useProductNavigationLinks';

import NavDropdown from './NavDropdown';

export default function ProductsDropdown() {
  const { user: currentUser } = useCurrentUser();
  const links = useProductNavigationLinks(currentUser);

  if (!currentUser) {
    return null;
  }

  return (
    <NavDropdown
      buttonLabel="Products"
      items={links.map(({ href, icon: Icon, label }) => ({
        href,
        label,
        icon: Icon ? <Icon /> : undefined,
      }))}
    />
  );
}
